import { userUserStore } from "@/state/user_state";
import { Auth, getAuth, SAMLAuthProvider, signInWithPopup, signOut, signInWithEmailAndPassword, sendPasswordResetEmail, createUserWithEmailAndPassword } from "firebase/auth";

export class AuthService {
    private static instance: AuthService;
    private auth: Auth;
    private constructor() {
       this.auth = getAuth();

       this.auth.onAuthStateChanged((user) => {
           userUserStore.setState({user: user});
       });
       userUserStore.setState({user: this.auth.currentUser});
    }

    public static getInstance(): AuthService {
        if (!AuthService.instance) {
            AuthService.instance = new AuthService();
        }
        return AuthService.instance;
    }

    public async signInWithSAML() {
        const provider = new SAMLAuthProvider('saml.microsoft-azure-breuer');
        try {
            await signInWithPopup(this.auth, provider);
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async signOut() {
        try {
            await signOut(this.auth);
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public getToken() {
        return this.auth.currentUser?.getIdToken();
    }

    public getUser() {
        return this.auth.currentUser;
    }

    public async signInWithEmailAndPassword(email: string, password: string) {
        try {
            await signInWithEmailAndPassword(this.auth, email, password);
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async sendPasswordResetEmail(email: string) {
        try {
            await sendPasswordResetEmail(this.auth, email);
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async createUserWithEmailAndPassword(email: string, password: string) {
        try {
            await createUserWithEmailAndPassword(this.auth, email, password);
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}
